// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kt_quick_user[data-v-7702ed62]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
